import ApiResourceManager from '../ApiResourceManager';

export default class DevelopersManager extends ApiResourceManager {
  listAccounts = () =>
    this.request({
      method: 'GET',
      url: '/developers/accounts',
    });

  createAccount = (data) =>
    this.request({
      method: 'POST',
      url: '/developers/accounts',
      data,
    });

  // company_ids is a full replacement: omit it to leave the attachments alone,
  // send [] to detach every restaurant.
  updateAccount = (accountId, data) =>
    this.request({
      method: 'PUT',
      url: `/developers/accounts/${accountId}`,
      data,
    });

  listEventTypes = () =>
    this.request({
      method: 'GET',
      url: '/developers/webhook-event-types',
    });

  listApiKeys = (accountId) =>
    this.request({
      method: 'GET',
      url: `/developers/accounts/${accountId}/api-keys`,
    });

  // The response carries the plaintext key exactly once (top-level `key`).
  createApiKey = (accountId, data) =>
    this.request({
      method: 'POST',
      url: `/developers/accounts/${accountId}/api-keys`,
      data,
    });

  revokeApiKey = (accountId, keyId) =>
    this.request({
      method: 'DELETE',
      url: `/developers/accounts/${accountId}/api-keys/${keyId}`,
    });

  listWebhookEndpoints = (accountId) =>
    this.request({
      method: 'GET',
      url: `/developers/accounts/${accountId}/webhook-endpoints`,
    });

  // The response carries the signing secret exactly once (top-level `secret`).
  createWebhookEndpoint = (accountId, data) =>
    this.request({
      method: 'POST',
      url: `/developers/accounts/${accountId}/webhook-endpoints`,
      data,
    });

  updateWebhookEndpoint = (accountId, endpointId, data) =>
    this.request({
      method: 'PUT',
      url: `/developers/accounts/${accountId}/webhook-endpoints/${endpointId}`,
      data,
    });

  deleteWebhookEndpoint = (accountId, endpointId) =>
    this.request({
      method: 'DELETE',
      url: `/developers/accounts/${accountId}/webhook-endpoints/${endpointId}`,
    });

  regenerateWebhookEndpointSecret = (accountId, endpointId) =>
    this.request({
      method: 'POST',
      url: `/developers/accounts/${accountId}/webhook-endpoints/${endpointId}/secret`,
    });

  listWebhookDeliveries = (accountId, params) =>
    this.request({
      method: 'GET',
      url: `/developers/accounts/${accountId}/webhook-deliveries`,
      params,
    });

  getWebhookDelivery = (accountId, deliveryId) =>
    this.request({
      method: 'GET',
      url: `/developers/accounts/${accountId}/webhook-deliveries/${deliveryId}`,
    });

  resendWebhookDelivery = (accountId, deliveryId) =>
    this.request({
      method: 'POST',
      url: `/developers/accounts/${accountId}/webhook-deliveries/${deliveryId}/resend`,
    });
}
